import { createDeepEqualSelector } from '../../utils/selectors';

import { selectAuth } from '../selectors';

export const selectNewsletterOptIn = createDeepEqualSelector(selectAuth, (auth) => auth.newsletterOptIn);
